import {
  getExpenses,
  getPaymentProviders,
  GetPaymentProvidersArgs,
  getStudentPurses,
  GetStudentPursesArgs,
  ListExpensesArgs,
} from '@/apis/providers/requests'
import { CustomQueryOptions } from '@/app/common/types_and_interfaces'
import { ProvidersResponse, PursesArray } from '@/schemas/provider.schema'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

export const useGetPaymentProviders = (
  queryParams: GetPaymentProvidersArgs
): UseQueryResult<ProvidersResponse, Error> => {
  return useQuery({
    queryKey: ['providers', queryParams],
    queryFn: () => getPaymentProviders(queryParams),
  })
}

export const useGetExpenseCategories = (args: ListExpensesArgs = {}) => {
  return useQuery({
    queryKey: ['expenses', args],
    queryFn: () => getExpenses(args),
  })
}

export function useStudentPurses(args: GetStudentPursesArgs, options: CustomQueryOptions<PursesArray> = {}) {
  return useQuery({
    queryKey: ['studentPurses', args],
    queryFn: () => getStudentPurses(args),
    ...options,
  })
}
